import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

export default async function activatePass(ticketPass) {
  if (ticketPass == null || ticketPass === "") {
    return Promise.reject(
      new Error("Missing ticket pass id — check entry access response (ticket_pass).")
    );
  }
  const response = await axios.post(
    routes.activatePass(ticketPass),
    {},
    {
      ...AXIOS_DEFAULT_CONFIG,
    }
  );

  return response;
}
